import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./layout/main-layout/main-layout.component').then(
        m => m.MainLayoutComponent
      ),
    // Do not protect the main layout so that the login modal can be displayed
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/dashboard/components/dashboard.component').then(
            m => m.DashboardComponent
          ),
      },
      {
        path: 'rma',
        loadChildren: () =>
          import('./features/rma/rma.routes').then(m => m.RMA_ROUTES),
        canActivate: [authGuard],
      },
      {
        path: 'terms',
        loadComponent: () =>
          import('./features/terms/components/terms-conditions.component').then(
            m => m.TermsConditionsComponent
          ),
        canActivate: [authGuard],
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./features/settings/components/settings.component').then(
            m => m.SettingsComponent
          ),
        canActivate: [authGuard],
      },
    ],
  },
  {
    path: '**',
    title: 'Not Found',
    loadComponent: () =>
      import('./pages/page-error/page-error.component').then(
        m => m.PageErrorComponent
      ),
  },
];
